import React, { useEffect } from "react";
import { delay, motion, useMotionValue, useSpring } from "framer-motion";
import { useCursor } from "../utils/useCursor";
import { ArrowRight } from "@mui/icons-material";

const MouseFollower = () => {
  const { css, text } = useCursor();
  const cursorX = useMotionValue(-100);
  const cursorY = useMotionValue(-100);

  const springConfig = { damping: 50, stiffness: 700, delay: 0.03 };
  const cursorXSpring = useSpring(cursorX, springConfig);
  const cursorYSpring = useSpring(cursorY, springConfig);
  // console.log(css);
  useEffect(() => {
    const moveCursor = (e) => {
      cursorX.set(e.clientX - 16);
      cursorY.set(e.clientY - 16);
    };

    window.addEventListener("mousemove", moveCursor);

    return () => {
      window.removeEventListener("mousemove", moveCursor);
    };
  }, []);

  return (
    <motion.div
      className=""
      transition={{ type: "tween", ease: "backOut" }}
      style={{
        position: "fixed",
        left: cursorXSpring,
        top: cursorYSpring,
        borderRadius: "50%",
        pointerEvents: "none",
        zIndex: 9999,
        alignItems: "center",
        ...css,
      }}
    >
      {text && <p className="text-white text-center mt-[30%]">{text}. </p>}
    </motion.div>
  );
};

export default MouseFollower;
